import React from 'react';
import {IconProps} from './IconProps';

export default function IconSearch({className, height, title}: IconProps) {
  return (
    <svg width={height} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={className}>
      <circle cx="9.5" cy="9.5" r="6.75" stroke="currentColor" strokeWidth="1.5"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M13.9697 15.0304L15.0304 13.9697L18.5001 17.4394C18.793 17.7323 18.793 18.2072 18.5001 18.5001C18.2072 18.793 17.7323 18.793 17.4394 18.5001L13.9697 15.0304Z"
            fill="currentColor"/>
    </svg>
  );
}
